export default __webpack_public_path__ + "static/media/user.fa57b2fe.jpg";